import React, { useEffect } from 'react';
import Head from 'next/head';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSegmentClientTag } from './clients';
import { initTracker } from './trackers';
import { useTrackerConfig } from './use-tracker-config';

/**
 * The analytics scripts component;
 *
 * Responsibilities:
 *  - adding <script /> tags for trackers
 *
 */
export const AnalyticsScripts: React.FC = () => {
  const flags = useFlags();
  // set the config for the tracker
  const config = useTrackerConfig();
  useEffect(() => {
    if (!config) {
      return;
    }
    initTracker(config);
  }, [config]);

  // https://app.launchdarkly.com/default/test/features/rollout.marketplace-sift-tracker
  const siftEnabled = flags['rollout.marketplace-sift-tracker'];

  // https://app.launchdarkly.com/default/test/features/rollout.consumer-segment-tracker
  const segmentEnabled = flags['rollout.consumer-segment-tracker'];

  useSegmentClientTag(segmentEnabled ? config?.segmentKey : null);
  return (
    <Head>
      {/* TODO: Use <Script> element after next.js 11 upgrade */}
      {/* FLOW(add-a-tracker).STEP_4b2: [optional] add <script /> tags for trackers here */}
      {siftEnabled && <script async src='https://cdn.sift.com/s.js' key='sift-sdk' />}
    </Head>
  );
};
